<template>
	<svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
		<path d="M32.25 20.4917V33.25H10.75V11.1439L32.25 20.4917Z" fill="#E5F6FD" stroke="#0074B5" stroke-width="1.5"/>
	</svg>
</template>
